import { ColDef } from "ag-grid-community";
import { BillingCostCellRenderer } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/billing-cost/BillingCostCellRenderer";
import { money } from "@/utils/numeral/money";

export const billingCostColumnDefField = "resource.billing_cost.total";

export const billingCostColumnDef: ColDef = {
  field: billingCostColumnDefField,
  headerName: "Billing Cost",
  width: 300,
  minWidth: 250,
  maxWidth: 350,
  cellStyle: { height: "100%" },
  cellRenderer: BillingCostCellRenderer,
  valueGetter: ({ data }) => {
    return money(data?.resource?.billing_cost?.total);
  },
  comparator: (_, __, nodeA, nodeB) => {
    const valueA = nodeA.data?.resource?.billing_cost?.total;
    const valueB = nodeB.data?.resource?.billing_cost?.total;

    if (typeof valueA !== "number") {
      return 1;
    }
    if (typeof valueB !== "number") {
      return -1;
    }

    return valueA > valueB ? 1 : -1;
  },
};
